export const ONLINE_INTERACTIVE_TEMPLATE_BY_TITLE = {
  'Best Time to Buy and Sell Stock': 'bestTimeToBuySellStock',
  'Search Insert Position': 'searchInsertPosition',
  'Move Zeroes': 'moveZeroes',
  'Maximum Subarray': 'maximumSubarray',
};
